import React from "react";
import { RequestState } from "src/models/RequestState";
import { FacultyItem } from "src/models/FacultyItem";
import { LetterSelector } from "src/components/LetterSelector";
import { css } from "aphrodite";
import { styles } from "./FacultyListPageStyles";
import { Api } from "src/core/api";
import axios from "axios";
import { JsonConvert } from "json2typescript";
import { ScaleLoader } from "react-spinners";

interface IFacultyListPageProps {
    index: string,
    history: any
}

class FacultyListPageState {
    public readonly requestState: RequestState = RequestState.NOT_ASKED;
    public readonly data: FacultyItem[] = [];
    public error: string = "";
    public readonly searchValue: string = "";
}

export class FacultyListPage extends React.Component<IFacultyListPageProps,FacultyListPageState> {

    constructor(props: IFacultyListPageProps){
        super(props);
        this.state = new FacultyListPageState()
    }
   
    public componentDidMount(){
        this.fetchData(this.props.index);
    }

    private fetchData = (letter: string) => {
        this.setState({...this.state, requestState: RequestState.LOADING});
        const url = `${Api.getEndPoint()}/faculty-list?index=${letter}`
        axios.get(url).then((res)=> {
            if(res.status === 200){
                try{
                    const jsonConvert = new JsonConvert();
                    const data = jsonConvert.deserializeArray(res.data, FacultyItem);
                    const newState = {...this.state, requestState: RequestState.SUCCESS, data: data, searchValue: ""}
                    this.setState(newState)
                }catch(error) {
                    const newState = {...this.state, requestState: RequestState.ERROR, error: error.toString()}
                    this.setState(newState)
                }
            }else{
                const error = res.statusText + ":" + res.data
                const newState = {...this.state, requestState: RequestState.ERROR, error: error}
                this.setState(newState)
            }    
        }).catch((err)=>{
            const error = err.toString();
            const newState = {...this.state, requestState: RequestState.ERROR, error: error}
            this.setState(newState)
        });
    }

    public render () {
        let content;
        if(this.state.requestState === RequestState.SUCCESS){
            const filteredData = this.state.data.filter(this.filterFaculty)
            content = (
                <React.Fragment>
                    <div id="faculty_list" className={css(styles.facultyList)}  >
                        {filteredData.map(this.buildFacultyItem)}
                    </div>
                </React.Fragment>
            )
        }else if(this.state.requestState === RequestState.LOADING){
            content = (
                    <div className={css(styles.loader)} >
                        <ScaleLoader
                            height={50}
                            width={5}
                            color={'#808080ff'}
                            loading={true}
                            />
                    </div>
            )
        }else if(this.state.requestState === RequestState.ERROR){
            content = (
                <div>
                    {this.state.error}
                </div>
            )
        }else{
            content = (
                <div>

                </div>
            );
        }
        return (
            <div className={css(styles.page)} >
                <LetterSelector selectedIndex={this.props.index} onSelected={this.onSelected} />
                <input type="text" placeholder={"Search"} className={css(styles.searchBox)} value={this.state.searchValue} onChange={this.onSearchValueChanged} >

                </input>
                <div id="content" >
                    {content}
                </div>
            </div>
        );
    }

    private onSearchValueChanged = (event: any) => {
        const value = event.target.value.trim();
        this.setState({...this.state, searchValue: value})
    }

    private filterFaculty = (faculty: FacultyItem) => {
        if(this.state.searchValue.length === 0){
            return true;
        }else{
            if(faculty.first_name.toLowerCase().includes(this.state.searchValue.toLowerCase())){
                return true;
            }else if(faculty.last_name.toLowerCase().includes(this.state.searchValue.toLowerCase())){
                return true;
            }else if(faculty.description.toLowerCase().includes(this.state.searchValue.toLowerCase())){
                return true;
            }else{
                return false;
            }
        }
    }


    private onSelected = (letter: string) => {
        this.fetchData(letter);
    }

    private buildFacultyItem = (facultyItem: FacultyItem, index: number) => {
        return (
            <div className={css(styles.itemContainer)} onClick={(e: any)=>{this.onFacultyItemClick(facultyItem)}}>
                <div className={css(styles.name)} >
                    {facultyItem.last_name} {facultyItem.first_name}
                </div>
                <div className={css(styles.affiliation)} >
                    {facultyItem.description}
                </div>
            </div>
        )
    }

    private onFacultyItemClick = (facultyItem: FacultyItem) => {
        const url = `/faculty/${facultyItem.faculty_id}`;
        this.props.history.push(url);
    }

}


// WEBPACK FOOTER //
// ./src/pages/FacultyListPage.tsx